import { render } from "./expenditureList.vue?vue&type=template&id=315f1efa&scoped=true&ts=true"
import script from "./expenditureList.vue?vue&type=script&lang=ts"
export * from "./expenditureList.vue?vue&type=script&lang=ts"

import "./expenditureList.vue?vue&type=style&index=0&id=315f1efa&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315f1efa"]])

export default __exports__